import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { StageService } from '../services/stage-modal.service';
import { BreadcrumbService, CoreService, HttpService, QueovalDateService } from '../../../../services';
import { Stage } from '../../../../models/formation/formation.model';
import { BObjectModel, BObjectSummary, GQueovalDik, Person, QResult, QueovalBase, QueovalDate, Select } from '../../../../models';
import { DynamicTagsSaveModel, StringBoProperty } from '../../../../models/bodisplay/dynamictags-inline/dynamictags-inline.model';
import { forkJoin, Observable, Subject } from 'rxjs';
import { of } from 'rxjs';
import { ToastService } from '../../../../toast';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TagComponent } from '../../../../tag';
import { map } from 'rxjs/operators';
import { DynamictagsInlineComponent } from '../../../../bodisplay/dynamictags-inline/dynamictags-inline.component';

@Component({
  selector: 'queoval-modal-pipe',
  templateUrl: './stage-modal.component.html',
  styleUrls: ['./stage-modal.component.css'],
  providers: [StageService]
})

export class StageModalComponent implements OnInit {

  public cursusList: StringBoProperty | null = null;
  public newResponsable: Person = new Person();
  public displayRequiredProperties: boolean = false;
  public isSaving: boolean = false;
  public modelBOStage: BObjectModel = new BObjectModel();
  public reloadRequiredProps: boolean = false;
  public lstMsgError: Array<string>;

  // Booléen pour rendre les dates éditables
  public IsDatedEditable: boolean;
  public IsDatefEditable: boolean;

  @ViewChild('tagComp', { static: false }) tagComp: TagComponent;
  @ViewChild('dynamictagsInline') dynamictagsInline: DynamictagsInlineComponent;

  @Output() isModeCursus: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private Breadcrumb: BreadcrumbService,
    public StageService: StageService,
    private indParam: CoreService,
    private http: HttpService,
    private cd: ChangeDetectorRef,
    private toast: ToastService,
    private modalService: NgbModal,
    private qDateService: QueovalDateService,
  ) {

    //StageService.Stage = Breadcrumb.ParamData;


    //Récupération dans le local storage pour savoir si le stage a été supprimé récemment (sans rechargement)
    //let stageIsDeleted = false;
    //const stagedeleted = localStorage.getItem(`DeletedStage`);
    //if (stagedeleted) {
    //  let lstIdStage = stagedeleted.split('|');
    //  const idStage = lstIdStage.filter(id => id == StageService.Stage.Ident);
    //  stageIsDeleted = (idStage && idStage.length > 0);
    //}

    //if (stageIsDeleted) {
    //  this.toast.showWarningToast('Stage supprimé');
    //  this.modalService.dismissAll();
    //}
    //else {
    let getStageDatas: Observable<QResult<Stage>> | Observable<null> = of(new QResult<Stage>());
    if (!StageService.Stage || !StageService.Stage.Ident || StageService.Stage.Ident == "0") {
      route.paramMap.subscribe(paramMap => {
        if (!StageService.Stage)
          StageService.Stage = new Stage();
        StageService.Stage.Ident = paramMap.get('id')!;
      });
      getStageDatas = this.StageService.GetStageData();
    }
    forkJoin([getStageDatas]).subscribe(
      (result: QResult<Stage>[]) => {
        if (!StageService.Responsable || (!StageService.Responsable.Id && (StageService.Responsable.Id as any) != 0)) {
          this.StageService.GetResponsableByStage().subscribe(() => { this.newResponsable = StageService.Responsable });
        } else {
          this.newResponsable = StageService.Responsable;
        }
      });

    Breadcrumb.ParamData = null;
    //}


  }

  public tabs: Array<{ Title: string, Icon: string, Route: string, }> = [
    { Route: 'vue360', Title: 'Vue 360°', Icon: 'far fa-eye', },
    { Route: 'effectif', Title: 'Effectif', Icon: 'fas fa-users', },
    { Route: 'planning', Title: 'Planning', Icon: 'far fa-calendar-alt', },
    { Route: 'convention', Title: 'Convention', Icon: 'fas fa-file-contract', },
    { Route: 'extranet', Title: 'Extranet', Icon: 'far fa-window-restore', },
    { Route: 'document', Title: 'Documents', Icon: 'far fa-file', },
    { Route: 'email', Title: 'Email', Icon: 'far fa-envelope', },
    { Route: 'certification', Title: 'Bilan/Certif', Icon: 'fas fa-money-check', },
    { Route: 'tache', Title: 'Taches', Icon: 'far fa-list-alt', },
    { Route: 'depense', Title: 'Dépenses', Icon: 'far fa-envelope', },
    { Route: 'test', Title: 'Tests', Icon: 'fas fa-tasks', },
    /*{ Route: 'mail', Title: 'Mail', Icon: 'far fa-envelope', },*/
    { Route: 'reporting', Title: 'Reporting', Icon: 'far fa-flag', },
  ];



  public ngOnInit(): void {

    forkJoin([this.StageService.GetCursusActifList(), this.StageService.GetCycleByStage()]).subscribe((result: [QResult<Array<Select>>, QResult<Select>]) => {
      const cursusList: StringBoProperty = new StringBoProperty();
      cursusList.Label = "Cursus";
      cursusList.Combo = new Array<GQueovalDik<string, string>>();
      result[0].Value.forEach(select => {
        const combo: GQueovalDik<string, string> = new GQueovalDik<string, string>();
        combo.Key = select.value;
        combo.Value = select.id;
        cursusList.Combo.push(combo);
      });

      // Cursus du stage
      cursusList.Value = result[1].Value.id ?? '';
      if (cursusList.Value != '') {
        // le cursus fait il parti de la liste des cursus actifs ?
        const index = cursusList.Combo.findIndex((cycle: GQueovalDik<string, string>) => cycle.Value === cursusList.Value);
        if (index == -1) {
          const selectedLine = new GQueovalDik<string, string>()
          selectedLine.Key = result[1].Value.value;
          selectedLine.Value = result[1].Value.id;
          cursusList.Combo.unshift(selectedLine);
        }
      }
      // Ajout de la valeur vide pour les stages sans cursus
      if (cursusList.Combo.length == 0 || (cursusList.Combo[0].Value != '' && cursusList.Combo[0].Value != '0' && cursusList.Combo[0].Value != null)) {
        const emptyLine = new GQueovalDik<string, string>()
        emptyLine.Key = '- - - - - -';
        emptyLine.Value = '';
        cursusList.Combo.unshift(emptyLine);
      }
      this.cursusList = cursusList;
    });

    this.StageService.isModeCursus.pipe(
      map((value: any) => {
        return value;
      })
    );
  }

  public OnActivateRouterOutlet(activateEvents: any): void {
    const arrayRoute: string[] = this.router.routerState.snapshot.url.split('/');
    this.displayRequiredProperties = arrayRoute.lastIndexOf('vue360') == arrayRoute.length - 1;
    this.cd.detectChanges();
  }

  public OnSelectCollab(collab: Array<Person>): void {
    if (!collab || collab.length == 0) {
      this.newResponsable = new Person();
      this.newResponsable.Id = "0";
    }
    else
      this.newResponsable = collab[0];
  }
  public OnSave(): void {
    if (this.qDateService.Compare(this.StageService.Stage.DateDebut, '<=', this.StageService.Stage.DateFin)) {
      if (this.isSaving) {
        this.toast.showInfoToast('sauvegarde en cours');
        return;
      }
      this.isSaving = true;

      this.dynamictagsInline.OnSave().subscribe(() => {
        for (let i: number = 0; i < this.dynamictagsInline.properties.length; i++) {
          if (this.dynamictagsInline.properties[i].ColumnName.toLowerCase() == 'clotepro') {
            this.StageService.Stage.Cloture = this.dynamictagsInline.properties[i].Value ?? false;
          }
        }
      });


      // enregistrement des dates du stages
      this.StageService.SaveDateStage().subscribe(() => { this.IsDatedEditable = false; this.IsDatefEditable = false; });

      this.tagComp.saveTag(this.StageService.Stage.Ident);
      forkJoin([
        this.StageService.ReplaceResponsable(this.newResponsable),
        this.StageService.ReplaceCycle(this.cursusList?.Value as string)]).subscribe(() => { this.isSaving = false; this.toast.showSuccessToast('Enregistrement effectué; pensez à vérifier le planning du stage '); })
    } else {
      this.toast.showAlertToast('Veuillez renseigner une date de début précédant la date de fin');
    }
  }

  onModeCursusChange(value: boolean): void {
    this.StageService.isModeCursus.next(value);
  }

  // Ouverture de la modal pour consulter/update le bo de l'effectif
  public open(Modal: any, identStage: string) {
    if (identStage) {
      this.modelBOStage = new BObjectModel();
      this.modelBOStage.IdDonneeFils = identStage;
      this.modelBOStage.IdDonneePere = "1348";
      this.modelBOStage.IdentBO = "BO_STAGE";
      this.modelBOStage.IdRelation = "REL_BO_CENT_BO_STAGE";
      this.modelBOStage.ShowSaveButton = true;
    }
    this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' }).result.then((result) => {
      switch (result) {
        case 'SAVE': break;
        case 'CANCEL': break;
      }
    });
  }


  /** 
* Ouverture de la modale de confirmation de suppression
*/
  public ConfirmModal(Modal: any) {
    this.lstMsgError = [];
    this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
  }

  public OnSaveBo(pBoModel: BObjectModel) {
    this.reloadRequiredProps = true;
    this.cd.detectChanges();
    this.reloadRequiredProps = false;

    const info_PRO: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'info_pro' });
    const NumStPRO: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'numstpro' });
    const ClotePRO: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'clotepro' });
    const DatedPRO: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'datedpro' });
    const DatefPRO: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'datefpro' });

    if (info_PRO?.length > 0) {
      this.StageService.Stage.Titre = pBoModel.Body.SelectedGroupsList[info_PRO[0].IndexGroupsList].DataList[info_PRO[0].IndexDataList].MainElementList[0].Value;
    }
    if (NumStPRO?.length > 0) {
      this.StageService.Stage.NumStage = Number(pBoModel.Body.SelectedGroupsList[NumStPRO[0].IndexGroupsList].DataList[NumStPRO[0].IndexDataList].MainElementList[0].Value);
    }
    if (ClotePRO?.length > 0) {
      this.StageService.Stage.Cloture = pBoModel.Body.SelectedGroupsList[ClotePRO[0].IndexGroupsList].DataList[ClotePRO[0].IndexDataList].MainElementList[0].Value == '1';
    }
    if (DatedPRO?.length > 0) {
      const strDateD: string = pBoModel.Body.SelectedGroupsList[DatedPRO[0].IndexGroupsList].DataList[DatedPRO[0].IndexDataList].MainElementList[0].Value;
      if (strDateD) { }
      this.StageService.Stage.DateDebut = this.qDateService.FromString(strDateD, 'dd/MM/yyyy');
    } else {
      this.StageService.Stage.DateDebut = new QueovalDate();
    }
    if (DatefPRO?.length > 0) {
      const strDateF: string = pBoModel.Body.SelectedGroupsList[DatefPRO[0].IndexGroupsList].DataList[DatefPRO[0].IndexDataList].MainElementList[0].Value;
      if (strDateF) { }
      this.StageService.Stage.DateFin = this.qDateService.FromString(strDateF, 'dd/MM/yyyy');
    } else {
      this.StageService.Stage.DateFin = new QueovalDate();
    }
  }

  /*
 * Supprimer la réservation
 */
  public Delete() {
    this.http.getHttp<QResult<Array<string>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Vue360/DELETE_STAGE/${this.StageService.Stage.Ident}`).subscribe((result: QResult<Array<string>>) => {
      this.lstMsgError = result.Value;
      // si pas de message d'erreur -> succès
      if (!this.lstMsgError || this.lstMsgError.length == 0) {
        this.toast.showSuccessToast('Suppression réussie');
        // fermeture de toutes les modales + suppression du stage dans le pipe
        this.modalService.dismissAll();
        this.Breadcrumb.Back();
      }
    });

  }

  public OnDuplicate(success: boolean, modal: any): void {
    if (success)
      modal.close('SAVE');
  }
  //#endregion Gestion Modal




  public goBackToPipe() {

    this.Breadcrumb.Back();
    // this.router.navigate([`view/formations/stage-pipe`]);
  }

  public OnRouting(tab: { Title: string, Icon: string, Route: string, }): void {
    let link: string = this.Breadcrumb.Breadcrumb[this.Breadcrumb.Breadcrumb.length - 1].link;
    const lstLink: Array<string> = link.split('/');
    if (this.tabs.filter(tab => tab.Route == lstLink[lstLink.length - 1]).length > 0) {
      lstLink[lstLink.length - 1] = tab.Route;
      link = lstLink.join('/');
    } else {
      lstLink.push(tab.Route);
      link = lstLink.join('/');
    }
    this.Breadcrumb.Breadcrumb[this.Breadcrumb.Breadcrumb.length - 1].link = link;
  }


}

